import { render, staticRenderFns } from "./ResumeCheckItem.vue?vue&type=template&id=55fe9a7b&scoped=true&"
import script from "./ResumeCheckItem.vue?vue&type=script&lang=js&"
export * from "./ResumeCheckItem.vue?vue&type=script&lang=js&"
import style0 from "./ResumeCheckItem.vue?vue&type=style&index=0&id=55fe9a7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fe9a7b",
  null
  
)

export default component.exports